import { Permissions } from "interface/role";
import React from "react";
import { Navigate } from "react-router-dom";
import addPermissions from "./routePermissions";

export type RouteProtectionProps = {
    children: JSX.Element;
    redirect: string;
    replace?: boolean;
    /**
     * if all a true then it's a valid route and content would be 
     * rendered but if any of the array item returns false then path would be redirected
     */
    validations: Array<boolean | (() => boolean)>;
    /**
     * called when  validations return false;
     */
    onInValid?: () => void;

    /**
     * Permissions required to access page
     */
    permissions?: Array<Permissions>;
    /**
     * Function to check permission
     * @returns true if user should have permission
     */
    permissionsFunction?: () => boolean;
  }
  
  function RouteProtection({ children, redirect, validations, replace, onInValid, permissions = [], permissionsFunction }: RouteProtectionProps ) {
    const canReplace = typeof replace === 'undefined' || replace;
    
    if (validations.length && !validations.every(value => {
      if(typeof value === 'function') {
        return value();
      }
      return value;
    })) {
      if(onInValid) {
        onInValid();
      }
      return <Navigate to={redirect} replace={canReplace} />
    }
  
    return addPermissions(children, permissions, permissionsFunction) as typeof children;
}

export default RouteProtection;